<template>
    <div class="table-list bill-list">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <bill-detail :billSeq="billSeq" :phone="tenantPhone"></bill-detail>
        <modal class="delete-bill" :display="modalStatus.deleteBill" @modalStatus="closeAlarmModal" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>帳單刪除</h1>
            <div class="content">
                確定刪除 ”{{billAddressName}}”的帳單嗎？記錄確認刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteBill(), $analyticsBiz.logEvent('帳單刪除', { screen_name: '帳單刪除'})">確認</button>
                <button class="border-button" @click="closeAlarmModal">取消</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="name">帳單名稱與名目</span>
            <span class="bill-date">
                應繳日
                <img @click="setOrder('billDate')" :class="{'rotate': order.billDate === 'ASC'}" src="@/assets/img/icon/order_arrow.svg" alt="">
            </span>
            <span class="bill-date">
                實際繳款日
                 <img @click="setOrder('paymentDate')" :class="{'rotate': order.paymentDate === 'ASC'}" src="@/assets/img/icon/order_arrow.svg" alt="">
            </span>
            <span class="period">收費區間</span>
            <span class="address">地址</span>
            <span class="tenant">租客</span>
            <span class="agent">業務</span>
            <span class="state">狀態</span>
            <span class="amount">帳單金額</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="financialBillList.length == 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <ul v-else>
                <li v-for="(list,index) in financialBillList" :key="index">
                    <span class="name">
                        <div class="title">
                            {{list.billName}}
                        </div>
                        <div class="list">
                            {{billItemList(list.billItemList).length >= 30?compressWord(billItemList(list.billItemList), 30):billItemList(list.billItemList)}}
                            <div v-if="billItemList(list.billItemList).length >= 30" class="full-word">
                                <span>
                                    {{billItemList(list.billItemList)}}
                                </span>
                            </div>
                        </div>
                    </span>
                    <span class="bill-date">{{list.createdDate}}</span>
                    <span class="bill-date">{{list.paymentDate?getFormatDateTime(list.paymentDate):'-'}}</span>
                    <span class="period">{{list.periodStartDate?list.periodStartDate+'~\n'+list.periodEndDate:'-'}}</span>
                    <span class="address">
                        {{list.address}}
                    </span>
                    <span class="tenant">{{list.tenantName}}</span>
                    <span class="agent">{{list.agentName}}</span>
                    <span class="state body blue" v-if="list.billStatus == 'COMPLETELY_PAID'">已收</span>
                    <span class="state body gray" v-if="list.billStatus == 'UNPAID'">未繳</span>
                    <span class="state body red" v-if="list.billStatus == 'OVERDUE'">欠款</span>
                    <span class="state body red" v-if="list.billStatus == 'PARTIAL_PAID'">部分繳款</span>
                    <span class="state body red" v-if="list.billStatus == 'LATE_PAYMENT'">逾期已收</span>
                    <span class="amount">{{toCurrency(list.receivableAmount)}}</span>
                    <span class="action">
                        <dot-dropmenu>
                            <ul >
                                <li v-if="bizAuth.viewBill.hasRight" @click="setBillDetail(list.billSeq), tenantPhone = list.tenantPhone">帳單明細</li>
                                <li v-if="bizAuth.viewBill.hasRight" @click="$router.push({name: 'bizEditBill', query: {seq: list.billSeq, contractSeq: list.contractSeq}})">編輯帳單</li>
                                <li v-if="list.billStatus == 'OVERDUE' && bizAuth.dunning.hasRight"
                                    @click="sendMsg(list.tenantPhone, list.billCid), $analyticsBiz.logEvent('欠款催繳', { screen_name: '欠款催繳'})">欠款催繳</li>
                                <li v-if="list.billStatus != 'COMPLETELY_PAID' && bizAuth.deleteBill.hasRight" @click="openAlarmModal(), billAddressName = list.address, billId = list.billCid">帳單刪除</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import BillDetail from '@/components/bussiness/widges/modals/BillDetail.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';

import {
    apiSendMsg,
    apiBizHadSent,
    apiBizDeleteBill
    } from "@/apis/api.js";


import { mapGetters } from 'vuex'
export default {
    data () {
        return{
            selected: 0,
            tenantPhone: null,
            billSeq: null,
            billAddressName: null,
            filterTotal: {
                all: 0,
                overdue: 0,
                paid: 0,
                unpaid: 0,
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            modalStatus: {
                deleteBill: false
            },
            order: {
                billDate: null,
                paymentDate: null
            }
        }
    },
    props: {
        state: '',
        isLoading: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        // filterByWord: {
        //     handler: function (val) {
        //         if(this.state === 'ALL'){
        //             this.$store.dispatch('setBizBillMgtFilterResult', val)
        //         }
        //     },
        //     immediate: true,
        //     deep: true
        // },
    },
    methods: {
        setOrder: function (type) {
            // console.log(type)
            // console.log(this.order.billDate)
            // console.log(this.order.paymentDate)
            this.isLoading = true
            let orderBy = null;
            let order = null;
            if(type === 'billDate'){
                this.order.paymentDate = null
                if(!this.order.billDate){
                    this.order.billDate = 'DESC'
                }else if(this.order.billDate === 'DESC'){
                    this.order.billDate = 'ASC'
                }else{
                    this.order.billDate = 'DESC'
                }
                orderBy = 'DUE_DATE';
                order = this.order.billDate;
            }else{
                this.order.billDate = null
                if(!this.order.paymentDate){
                    this.order.paymentDate = 'DESC'
                }else if(this.order.paymentDate === 'DESC'){
                    this.order.paymentDate = 'ASC'
                }else{
                    this.order.paymentDate = 'DESC'
                }
                orderBy = 'PAY_DATE';
                order = this.order.paymentDate;
            }
            this.$store.dispatch('setBizBillMgtFilterQuery', {orderBy: orderBy, order: order, page: 1})
              .then(()=>{
                this.$store.dispatch('getBizBillMgtListV2')
                  .then(()=>{
                    this.isLoading = false
                  })
              })
        },
        setFilterDefault: function () {
            this.$store.dispatch('setBizBillMgtFilterDefault')
        },
        // getFormatDate: function (time){
        //     var formatDate = [];
        //     var date = new Date(time);
        //     //一般日期 年 月 天 時 分
        //     formatDate[0] = date.getFullYear();
        //     formatDate[1] = date.getMonth()+1;
        //     formatDate[2] = date.getDate();
        //     formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
        //     formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
        //     //月及天兩位數
        //     formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
        //     formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
        //     // console.log(formatDate[3] )
        //     //換算時區 台灣-8
        //     if(formatDate[3] - 8 < 0){
        //         formatDate[3] = 24+(formatDate[3]-8);
        //         formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
        //     }else{
        //         formatDate[3] = formatDate[3]-8;
        //         formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
        //     }
        //     return formatDate[0]+'.'+formatDate[5]+'.'+formatDate[6];
        // },
        setBillDetail: function (billSeq) {
            this.$analyticsBiz.logEvent('帳單明細', { screen_name: '帳單明細'})
            this.billSeq = billSeq
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizBillDetail'})
            this.$store.commit('modalStatus/set_modal_mode', true)
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
        },
        sendMsg: function (phone, billCid) {
            let data = {
                "account": phone,
                "title":"",
                "message":"您有一筆租金尚未繳款，請立即開啟確認"
            }

            apiSendMsg(data)
            .then(res => {
                if(res.data.status == "SUCCESS"){
                    this.alart.success = true
                    this.msg.success = '催款訊息送出成功'
                    this.setHadSent(billCid)
                }else{
                    this.alart.error = true
                    this.msg.success = '催款訊息送出失敗'
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        setHadSent: function (billCid) {
            let data = {
                "billCid" : billCid,
                "hadSent" : true
            }

            apiBizHadSent(data)
            .then(res => {
                if(res.data.status == "SUCCESS"){
                    this.$store.dispatch('getBizBillMgtList')
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        openAlarmModal: function () {
            this.modalStatus.deleteBill = true
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        closeAlarmModal: function () {
            this.$store.commit('modalStatus/set_modal_mode', false)
            this.modalStatus.deleteBill = false
        },
        deleteBill: function () {
            this.$analyticsBiz.logEvent('帳單刪除', { screen_name: '帳單刪除'})
            let data = {
                "billCid": this.billId
            }
            apiBizDeleteBill(data)
            .then( res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('getBizBillMgtList')
                    this.closeAlarmModal()
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getFormatDate: function (date){
            var formatDate = [];
            var date = new Date(date);
            // var date = new Date(Date.parse(date));
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
            // return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6]+' '+formatDate[3]+':'+formatDate[4];
        },
        billItemList : function (list) {
            let string = ''
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                string += element
                if(i < list.length-1){
                    string += '、'
                }
            }
            return string
        }
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }else{
        //         return 0
        //     }

        // },
    },
    computed: {
        // filterByOrder: function () {
        //     let _self = this
        //     return this.financialBillList.slice().sort(function (a, b) {
        //         if(_self.order.billDate === 'DESC'){
        //             return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
        //         }else if(_self.order.billDate === 'ASC'){
        //             return new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime();
        //         }else if(_self.order.paymentDate === 'DESC'){
        //             return new Date(b.paymentDate).getTime() - new Date(a.paymentDate).getTime();
        //         }else if(_self.order.paymentDate === 'ASC'){
        //             return new Date(a.paymentDate).getTime() - new Date(b.paymentDate).getTime();
        //         }else{
        //             return _self.financialBillList
        //         }
        //     });

        // },
        // filterByState: function () {
        //     return this.filterByOrder.filter((item) => {
        //         // console.log(item)
        //         if( this.state == 'OVERDUE' ){
        //             if( item.filterBillStatus == 'OVERDUE' ){
        //                 return item
        //             }
        //         }else if( this.state == 'COMPLETELY_PAID' ){
        //             if( item.filterBillStatus == 'COMPLETELY_PAID' ){
        //                 return item
        //             }
        //         }else if( this.state == 'UNPAID' ){
        //             if( item.filterBillStatus == 'UNPAID' ){
        //                 return item
        //             }
        //         }else{
        //             return item
        //         }
        //     });
        // },
        // filterByCounty: function () {
        //     return this.filterByState.filter((item) => {
        //         if(this.filterQuery.county){
        //             if(item.city === this.filterQuery.county){
        //                 return item
        //             }
        //         }else{
        //             return item
        //         }
        //     });
        // },
        // filterByDistrict: function () {
        //     return this.filterByCounty.filter((item) => {
        //         if( this.filterQuery.district){
        //             if(item.district === this.filterQuery.district ){
        //                 return item
        //             }
        //         }else{
        //             return item
        //         }
        //     });
        // },
        // filterByAmount: function () {
        //     return this.filterByDistrict.filter((item) => {
        //         if( this.filterQuery.amount ){
        //             if( this.filterQuery.amount[1] >= 100000){
        //                 if( this.filterQuery.amount[0] <= item.receivableAmount){
        //                     return item
        //                 }
        //             }else{
        //                 if( this.filterQuery.amount[0] <= item.receivableAmount && this.filterQuery.amount[1] >= item.receivableAmount ){
        //                     return item
        //                 }
        //             }

        //         }else{
        //             return item
        //         }
        //     });
        // },
        // filterByGroup: function () {
        //     return this.filterByAmount.filter((item) => {
        //         if(this.filterQuery.group){
        //             if(item.groupName == this.filterQuery.group ){
        //                 return item
        //             }
        //         }else{
        //             return item
        //         }
        //     });
        // },
        // filterBySales: function () {
        //     return this.filterByGroup.filter((item) => {
        //         if(this.filterQuery.member){
        //             if(item.agentName == this.filterQuery.member ){
        //                 return item
        //             }
        //         }else{
        //             return item
        //         }
        //     });
        // },
        // filterByCategory: function () {
        //     return this.filterBySales.filter((item) => {
        //         if(this.filterQuery.category){
        //             if(item.billType == this.filterQuery.category ){
        //                 return item
        //             }
        //         }else{
        //             return item
        //         }
        //     });
        // },
        // filterByDate: function () {
        //     return this.filterByCategory.filter((item) => {
        //         // console.log(this.filterQuery)
        //         if( this.filterQuery.date.length == 2 ){
        //             let ledger = Date.parse(item.createdDate).valueOf()-28800000,
        //                 filterLedgerStart = this.filterQuery.date[0],
        //                 filterLedgerEnd = this.filterQuery.date[1]
        //             if( filterLedgerStart <= ledger && ledger <= filterLedgerEnd ){
        //                 return item
        //             }
        //         }else{
        //             return item
        //         }
        //     });
        // },
        // filterByWord: function () {
        //     return this.filterByDate.filter((item) => {
        //         if( this.filterWord ){
        //             if( item.billName.includes(this.filterWord) || item.tenantName.includes(this.filterWord) || item.address.includes(this.filterWord)){
        //                 return item
        //             }
        //         }else{
        //             return item
        //         }
        //     });
        // },
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            financialBillList: 'GET_BIZ_BILL_MGT_LIST',
            filterQuery: 'GET_BIZ_BILL_MGT_FILTER_QUERY',
            filterWord: 'GET_BIZ_BILL_MGT_FILTER_WORD',
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        AlartMsg,
        Modal,
        BillDetail,
        tableLoading,
    }
}
</script>
<style lang="scss">
    .table-list.bill-list{
        // .table-list-title .house:before{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     top: 2px;
        //     border-style: solid;
        //     border-width: 0 2.5px 4px 2.5px;
        //     border-color: transparent transparent #525956 transparent;
        // }
        // .table-list-title .house:after{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     bottom: 1px;
        //     border-style: solid;
        //     border-width: 4px 2.5px 0 2.5px;
        //     border-color: #525956 transparent transparent transparent;
        // }
        margin-bottom: 0px !important;
        #modal.delete-bill{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #676362;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
        .table-list-title .name,
        .table-list-body ul li .name{
            width: 210px;
            margin-right: 10px;
        }
        .table-list-body ul li .name{
            .title{
                margin-bottom: 2px;
            }
            .list{
                display: flex;
                flex-wrap: wrap;
                color: #a19d9c;
                line-height: 1.5;
                >span{
                    display: flex;
                }
            }
            .full-word{
                width: 200px;
                top: 71%;
                z-index: 3;
                line-height: 1.5;
            }
        }
        .table-list-title .bill-date,
        .table-list-body ul li .bill-date{
            position: relative;
            width: 90px;
            margin-right: 10px;
            .rotate{
                transform: rotate(180deg);
            }
            >img{
                margin-left: 4px;
                cursor: pointer;
            }
        }
        .table-list-title .period,
        .table-list-body ul li .period{
            width: 100px;
            margin-right: 8px;
        }
        .table-list-title .address,
        .table-list-body ul li .address{
            width: 240px;
            margin-right: 10px;
            line-height: 1.5;
        }
        .table-list-title .tenant,
        .table-list-body ul li .tenant{
            width: 42px;
            margin-right: 10px;
            word-break: break-all;
        }
        .table-list-title .agent,
        .table-list-body ul li .agent{
            width: 42px;
            margin-right: 10px;
        }
        .table-list-title >.amount,
        .table-list-body ul li >.amount{
            width: 63px;
            margin-right: 10px;
            text-align: right;
        }
        .table-list-title .state,
        .table-list-body ul li .state{
            width: 76px;
            margin-right: 10px;
        }
        .table-list-body ul li .state.body{
            height: 38px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
        }
        .table-list-body ul li .state.blue{
            background-color: rgba(113, 170, 229, 0.1);
            color: #71aae5;
        }
        .table-list-body ul li .state.red{
            background-color: rgba(255, 146, 117, 0.1);
            color: #fc7171;
        }
        .table-list-body ul li .state.gray{
            background-color: #f3f3f3;
            color: #676362;
        }
    }
    // @media screen and (max-width: 1280px){
    //     .table-list.bill-list{
    //         .table-list-title .house,
    //         .table-list-body ul li .house{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .tanant,
    //         .table-list-body ul li .tanant{
    //             margin-right: 54px;
    //         }
    //         .table-list-title .phone,
    //         .table-list-body ul li .phone{
    //             margin-right: 64px;
    //         }
    //         .table-list-title .address,
    //         .table-list-body ul li .address{
    //             margin-right: 44px;

    //         }
    //         .table-list-title .rent,
    //         .table-list-body ul li .rent{
    //             margin-right: 32px;
    //         }
    //         .table-list-title .leave-date,
    //         .table-list-body ul li .leave-date{
    //             margin-right: 70px;
    //         }
    //     }

    // }
</style>



// WEBPACK FOOTER //
// src/components/bussiness/financialReport/billMgt/billMgtList.vue